import { ENGINEERING_SYSTEMS_CDN_PATH } from '../../../engineering-systems-constants';
import { HeaderSectionStructure } from '../../../components/header-section/header-section-types';

export const POWER_SUPPLY_HEADER_SECTION_CONFIG: HeaderSectionStructure = {
  title: 'Системы электроснабжения',
  description:
    'Спроектируем и\u00A0установим систему электроснабжения любой сложности под ключ. Выполняем работы от\u00A0прокладки кабеля и\u00A0установки розеток до\u00A0сборки электрических и\u00A0слаботочных щитов. Оформите заявку, а\u00A0мы\u00A0подберём решение, составим проект и\u00A0установим оборудование у\u00A0вас дома.',
  img: {
    src: `${ENGINEERING_SYSTEMS_CDN_PATH}/systems/v2-3.jpg/v2-3.jpg`,
    alt: 'Системы электроснабжения',
  },
  consultationSignupBtn: {
    elementBlock: 'landingSistemyElektrosnabzheniya',
    label: 'Записаться на консультацию',
    elementText: 'Системы электроснабжения',
  },
};
